<template>
  <input type="text" class="form-control"
         v-mask="mask"
         :value="value"
         v-bind="$attrs"
         @input="$emit('input', $event.target.value)"
         @blur="clearIncompleteField()">
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  name: 'MaskedInput',
  directives: { mask },
  inheritAttrs: false,
  props: {
    value: { type: String },
    mask: [String, Array],
    clearIncomplete: { type: Boolean, default: true }
  },

  mounted () {
    this.clearIncompleteField()
  },

  methods: {
    clearIncompleteField: function () {
      if (!this.mask || !this.clearIncomplete) return

      if (Array.isArray(this.mask)) {
        const valueMatchesMask = this.mask.some(m => this.value.length === m.length)
        if (valueMatchesMask) return

        this.$emit('input', '')
      } else if (this.value.length < this.mask.length) {
        this.$emit('input', '')
      }
    }
  }
}
</script>

<style scoped>

</style>
